import { BUSINESS } from '../config/business';
import { useLang } from '../context/LanguageContext';

export default function SubscribeBillingNotice() {
  const { t } = useLang();
  return (
    <p className="sub-gate__billing">
      {t.subscribeBillingNotice
        .replace('{business}', BUSINESS.legalName)
        .replace('{gstin}', BUSINESS.gstin)}
    </p>
  );
}
